import { useState } from "react";
import imgDefault from './../../assets/imgEditPerfil/user.png';

interface ImageWithPreloaderProps {
  src: string;
  alt: string;
  className?: string;
}

const ImageWithPreloader = ({ src, alt, className = "" }: ImageWithPreloaderProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  const containerClasses = "w-20 h-20 flex-shrink-0 mr-4 relative";
  const imageClasses = "object-cover object-center rounded-full";

  return (
    <div className={containerClasses}>
      {!imageLoaded && !hasError && (
        <div className="absolute inset-0 bg-gray-100 rounded-full flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-Yellow"></div>
        </div>
      )}

      <img
        alt={alt}
        className={`w-full h-full ${imageClasses} ${className} ${
          imageLoaded ? 'block' : 'hidden'
        }`}
        src={hasError ? imgDefault : src || imgDefault}
        onLoad={() => setImageLoaded(true)}
        onError={() => {
          setHasError(true);
          setImageLoaded(true);
        }}
        style={{ aspectRatio: '1/1' }}
      />
    </div>
  );
};

export default ImageWithPreloader;